export const isValidName = (value) => {
  if (!value || typeof value !== "string") return false;
  return /^[a-zA-Z\\s'-]+$/.test(value.trim());
};

export const isValidEmail = (value) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
};

export const formatPhoneNumber = (value) => {
  const cleaned = value.replace(/\D/g, "").slice(0, 10);
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (!match) return value;
  const [, area, mid, end] = match;
  if (cleaned.length < 4) return area;
  if (cleaned.length < 7) return `(${area}) ${mid}`;
  return `(${area}) ${mid}-${end}`;
};

export const isValidPhone = (value) => {
  return value.replace(/\D/g, "").length === 10;
};
